import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  regretData: null,
};

const regretDashboardSlice = createSlice({
  name: "regretDashboard",
  initialState,
  reducers: {
    fetchRegretData: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchRegretDataSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.regretData = action.payload?.data;
    },
    fetchRegretDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.regretData = null;
    },
    clearRegretData: (state) => {
      state.regretData = null;
      state.error = null;
    },
  },
});

export const { actions, reducer } = regretDashboardSlice;
export const sliceKey = regretDashboardSlice.name;